export default "__VITE_ASSET__0qawhCED__"